import { render, staticRenderFns } from "./LanguangeSwitcher.vue?vue&type=template&id=386e4bfe&scoped=true"
import script from "./LanguangeSwitcher.vue?vue&type=script&lang=js"
export * from "./LanguangeSwitcher.vue?vue&type=script&lang=js"
import style0 from "./LanguangeSwitcher.vue?vue&type=style&index=0&id=386e4bfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386e4bfe",
  null
  
)

export default component.exports